import {
    SpaceBetween,
    BreadcrumbGroup,
    Flashbar,
    Header,
    Container,
    Form,
    FormField,
    Input,
    Button,
    TextContent,
} from '@amzn/awsui-components-console';
import React, { useEffect, useState } from 'react';
import { createApiToken } from '../apis';
import { getHiddenToken } from '../utils';
import * as LocalConstants from '../constants';
import * as GlobalConstants from '../../../lib/constants';

export default function CreateApiTokens() {
    const [securityNote, setSecurityNote] = React.useState([
        {
            type: 'info',
            dismissible: true,
            dismissLabel: 'Dismiss message',
            onDismiss: () => setSecurityNote([]),
            content: <>Do not share or distribute any tokens within or outside Amazon.</>,
        },
    ]);
    const [successMessage, setSuccessMessage] = React.useState([]);
    const [errorMessage, setErrorMessage] = React.useState([]);
    const [descriptionValue, setDescriptionValue] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const displayErrorContent = (header, content) => {
        // display error message
        setErrorMessage([
            {
                header: header,
                type: 'error',
                dismissible: true,
                dismissLabel: 'Dismiss message',
                onDismiss: () => setErrorMessage([]),
                content: <>{content}</>,
                action: (
                    <Button href={GlobalConstants.CONTACT_US} iconAlign="right" target="_blank">
                        Contact us
                    </Button>
                ),
            },
        ]);
    };
    const displaySuccessContent = (header, content) => {
        // display success message
        setSuccessMessage([
            {
                header: header,
                type: 'success',
                dismissible: true,
                dismissLabel: 'Dismiss message',
                onDismiss: () => setSuccessMessage([]),
                content: <>{content}</>,
            },
        ]);
    };
    const onClick = () => {
        (async function () {
            setLoading(true);
            setErrorMessage([]);
            setSuccessMessage([]);
            try {
                const response = await createApiToken(descriptionValue);
                const token = response[LocalConstants.token];
                const hiddenToken = getHiddenToken(token);
                displaySuccessContent('API key created. Copy to get the full token.', hiddenToken);
            } catch (err) {
                console.error(err);
                const errResponse = err.response;
                if (errResponse && errResponse.data && errResponse.status == 400) {
                    const errorException = errResponse.data.errorException;
                    const errorMessage = errResponse.data.errorMessage;
                    displayErrorContent(`[${errorException}]`, `${errorMessage}`);
                } else {
                    displayErrorContent(
                        '',
                        'Cannot create user token, Contact our dev team @ds2-device-farm-dev for more details.'
                    );
                }
            }
            setDescriptionValue('');
            setLoading(false);
        })();
    };
    return (
        <SpaceBetween size="s">
            <Flashbar items={securityNote} />
            <BreadcrumbGroup
                items={[
                    { text: 'DS2 Device Farm', href: '#' },
                    { text: 'API tokens', href: '#/api-auth/personal-tokens' },
                    { text: 'Create', href: '#/api-auth/personal-tokens/create' },
                ]}
                ariaLabel="Breadcrumbs"
            />
            <Header
                variant="h1"
                description="The description for this api key will be attached to this user and shown alongside the api key. To protect your token, only the last 5 characters of it is shown, copy to get the full token."
            >
                Set description tag - optional
            </Header>
            <form onSubmit={(e) => e.preventDefault()}>
                <Form
                    actions={
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button formAction="none" href="#/api-auth/personal-tokens">
                                Back
                            </Button>
                            <Button formAction="none" loading={loading} onClick={onClick} variant="primary">
                                Create
                            </Button>
                        </SpaceBetween>
                    }
                >
                    <SpaceBetween direction="vertical" size="s">
                        <Container header={<Header variant="h2">API key best practices</Header>}>
                            <TextContent>
                                <ul>
                                    <li>Never store api key in plain text, in a code repository, or in code.</li>
                                    <li>Delete api key when no longer needed.</li>
                                    <li>
                                        Rotate api keys regularly. By default, any api key in DS2 Device Farm will be
                                        automatically deleted in 90 days after creation.
                                    </li>
                                </ul>
                            </TextContent>
                        </Container>
                        <Container header={<Header variant="h2">Description details</Header>}>
                            <FormField
                                label="Description value - optional"
                                description="Describe the purpose of this api key and where it will be used. A good description will help you rotate this api key confidently later."
                            >
                                <Input
                                    placeholder="Enter description"
                                    value={descriptionValue}
                                    onChange={(event) => setDescriptionValue(event.detail.value)}
                                />
                            </FormField>
                        </Container>
                    </SpaceBetween>
                </Form>
            </form>
            <Flashbar items={errorMessage} />
            <Flashbar items={successMessage} />
        </SpaceBetween>
    );
}
